import React from 'react'
import { AiOutlineClose } from 'react-icons/ai'
import * as S from './styles'
import { ModalHeaderProps } from './types'

export function ModalHeader({ closeModal, modalHeader, hideCloseButton = false, ...props }: ModalHeaderProps) {
  return (
    <S.Wrapper className="modal-header" {...props}>
      <S.Heading>{modalHeader}</S.Heading>

      {!hideCloseButton && (
        <S.CloseButton type="button" aria-label="close" onClick={closeModal}>
          <AiOutlineClose size={15} />
        </S.CloseButton>
      )}
    </S.Wrapper>
  )
}
